export enum UserRole{
    ADMIN = "Administrator",
    TSE = "Technical Support Engineer",
    FSE = "Field Service Engineer",
    RM = "Release Manager"
}